module.exports = __webpack_public_path__ + "img/about_us_01.107105b9.jpg";